
import CryptoJS from "crypto-js";
import { AuthEntry } from "../AppManager";

export default class HelperEncryptShort {
  private static SECRET_KEY = "infosalud2 2026";

  static encrypt(data: AuthEntry): string {
    // 1. Convertir data a string 
    let dataString = data.User + "|" + data.Password;
    const key=CryptoJS.SHA256(this.SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.create(key.words.slice(0, 4));
    // 2. Encriptar con AES (CryptoJS devuelve Base64 normal)
    const ciphertext = CryptoJS.AES.encrypt(dataString, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString();
    // 3. Convertir a Base64 URL-safe
    return this.toUrlSafeBase64(ciphertext);
  }

  // Decrypt
  static decrypt(encryptedData: string): AuthEntry {
    // 1. Convertir de Base64 URL-safe a Base64 normal
    const base64 = this.fromUrlSafeBase64(encryptedData);

    const key=CryptoJS.SHA256(this.SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.create(key.words.slice(0, 4));

    // 2. Desencriptar con AES
    const bytes = CryptoJS.AES.decrypt(base64, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    // 3. Convertir a string UTF-8
    const text = bytes.toString(CryptoJS.enc.Utf8);
    // 4. Separar User y Password
    const [User, Password] = text.split("|");


    return { User, Password };
  }

  private static toUrlSafeBase64(base64: string): string {
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  private static fromUrlSafeBase64(urlSafe: string): string {
    let base64 = urlSafe.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) base64 += "="; // Rellenar padding si falta
    return base64;
  }
}

